// Utilización por Segmento — días-auto rentados ÷ días-auto disponibles en
// el periodo, expresado como % por segmento × CP/LP. La columna "Total" es
// el promedio ponderado por días disponibles, calculado en el frontend.
//
// Cubre las dos flotas: autos propios (disponibles = todos los días del
// periodo) y unidades subarrendadas (disponibles = sólo los días que la unidad
// estuvo en poder de GoMove, que es cuando puede rentarse).
import supabase from "../../../supabase-client";

const fmtPct = (v) => `${(Number(v) * 100).toFixed(1)}%`;

export const utilizationBySegmentReport = {
  id: "utilization-by-segment",
  title: "Utilización por Segmento",
  description: "Porcentaje de utilización por segmento y sucursal en el periodo, incluyendo unidades subarrendadas.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  pivot: {
    rowKey: "segment",
    colKey: "branch",
    valueKey: "value",
    rowLabel: "Utilización",
    // The RPC returns synthetic "Total" rows/cols with proper weighted-
    // average math (sum_rented / sum_available across cars), so the framework
    // doesn't need to compute totals itself.
    rowOrder: ["Carga", "Pasajeros", "Sedanes", "Total"],
    colOrder: ["CP", "LP", "Total"],
    format: fmtPct,
    exportType: "percent",
    showTotals: false,
  },
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_utilization_segment", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
